import { Blockchain } from "@/shared/config/blockchain/types";
import { Nft, ShortNft } from "../nfts/types";
import { ShortUser } from "../users/types";
import { Collection } from "../collections/types";

export enum OrderType {
  FIXED_AUCTION = "FIXED_AUCTION",
  DUTCH_AUCTION = "DUTCH_AUCTION",
  RESERVE_AUCTION = "RESERVE_AUCTION",
  PRIVATE_AUCTION = "PRIVATE_AUCTION",
  OFFER = "OFFER",
}

export const TimedAuctions = [
  OrderType.DUTCH_AUCTION,
  OrderType.RESERVE_AUCTION,
  OrderType.PRIVATE_AUCTION,
];

interface BaseSignedOrder {
  id?: string;
  type?: OrderType;
  orderNonce?: string;
  nftContract: string;
  tokenId: number;
  paymentErc20TokenAddress: string;
  buyer?: string;
  seller?: string;
  expiresAt?: number;
  startingAt?: number;
  price?: string;
  totalPrice?: string;
  priceInUSD?: string;
  endingPrice?: string;
  signature?: string;
  blockchain?: Blockchain;
  nft?: ShortNft;
  makerFee?: number;
  takerFee?: number;
  royaltiesFee?: number;
  royaltiesRecipient?: string;
  collectiveFee?: number;
  collectiveRecipient?: string;
}

interface SignedSaleOrder extends BaseSignedOrder {
  price?: string;
}

interface DutchAuctionOrder extends BaseSignedOrder {
  startingPrice: string;
  endingPrice: string;
  startingAt: number;
  duration: number;
}

interface ReserveAuctionOrder extends BaseSignedOrder {
  totalPrice: string;
  price: string;
  isBid: boolean;
}

interface OfferOrder extends BaseSignedOrder {
  isForCollection: boolean;
  expiresAt: number;
  NftContract?: Collection;
  Buyer?: ShortUser;
  nft?: Nft;
}

interface OrderQuery {
  nftContract: string;
  tokenId: number;
  type: string;
}

type AuctionOrder = SignedSaleOrder | DutchAuctionOrder | ReserveAuctionOrder;

type Order =
  | SignedSaleOrder
  | DutchAuctionOrder
  | ReserveAuctionOrder
  | OfferOrder;

export type {
  BaseSignedOrder,
  SignedSaleOrder,
  DutchAuctionOrder,
  ReserveAuctionOrder,
  AuctionOrder,
  OfferOrder,
  Order,
  OrderQuery,
};
